export interface TVShow {
  id: string;
  title: string;
  titleEn: string;
  year: number;
  category: string;
  genre: string;
  rating: number;
  episodes: string;
  director: string;
  cast: string[];
  description: string;
  longDescription: string;
  posterSeq: string;
  posterWidth: number;
  posterHeight: number;
  isNew: boolean;
  isHot: boolean;
  updateDate: string;
  tags: string[];
}

export const allTVShows: TVShow[] = [
  {
    id: 'tv-1',
    title: '繁花',
    titleEn: 'Blossoms Shanghai',
    year: 2024,
    category: 'tv',
    genre: '剧情',
    rating: 9.3,
    episodes: '30集全',
    director: '王家卫',
    cast: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾', '游本昌'],
    description: '九十年代的上海，阿宝凭借改革开放的春风，从平凡青年成长为商界后起之秀。在黄河路上，他经历了商海浮沉与情感纠葛。',
    longDescription: '九十年代初的上海，处处是机遇与挑战。阿宝，一个从上海弄堂里走出来的年轻人，凭借敏锐的商业嗅觉和一腔热血，在汹涌的改革开放浪潮中逐步崛起。从服装生意到外贸，从黄河路到南京路，阿宝的每一步都充满着传奇色彩。在这条充满诱惑与陷阱的路上，他遇到了形形色色的人——神秘的李李、精明的玲子、纯真的汪小姐。商海沉浮间，阿宝逐渐领悟到人生真谛。王家卫导演首部电视剧作品，以极致的视听美学还原了那个火热的年代。',
    posterSeq: 'tv-poster-01',
    posterWidth: 400,
    posterHeight: 560,
    isNew: false,
    isHot: true,
    updateDate: '2024-01-09',
    tags: ['王家卫', '年代剧', '沪语', '金鹰奖'],
  },
  {
    id: 'tv-2',
    title: '庆余年第二季',
    titleEn: 'Joy of Life Season 2',
    year: 2024,
    category: 'tv',
    genre: '古装',
    rating: 9.1,
    episodes: '36集全',
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟'],
    description: '范闲从北齐归来后，面对更加复杂的朝廷局势。庆帝的制衡、二皇子的虎视眈眈，让他在京都的每一步都如履薄冰。',
    longDescription: '范闲率领使团回归途中，二皇子以费介、范思辙以及滕家遗孤的安危来威胁范闲，逼他向自己俯首称臣。范闲对二皇子所言的抱月楼事件加以追查，从而引出了二皇子与长公主李云睿的勾结。回到京都后，范闲发现京都暗流涌动，庆帝对范闲的态度也变得更加微妙。他在江南明家的斗争中，逐步揭开春闱舞弊案的真相，也在一次次生死考验中不断成长。',
    posterSeq: 'tv-poster-02',
    posterWidth: 400,
    posterHeight: 560,
    isNew: false,
    isHot: true,
    updateDate: '2024-05-16',
    tags: ['古装', '权谋', '热门IP', '原班人马'],
  },
  {
    id: 'tv-3',
    title: '狂飙',
    titleEn: 'The Knockout',
    year: 2023,
    category: 'tv',
    genre: '犯罪',
    rating: 9.4,
    episodes: '39集全',
    director: '徐纪周',
    cast: ['张译', '张颂文', '李一桐', '张志坚', '吴刚'],
    description: '一线刑警安欣在与黑恶势力的斗争中，不断遭到保护伞的打击，始终无法将犯罪分子绳之以法。二十年后，全国政法队伍教育整顿工作开展，安欣协同专案组彻查犯罪团伙。',
    longDescription: '2000年，意气风发的刑警安欣与备受欺负的鱼贩高启强相识。二十年间，两人的人生轨迹发生了天翻地覆的变化——安欣在与黑恶势力斗争的过程中屡屡受挫，从年轻刑警变成了满头白发的中年人；而高启强则一步步走上了犯罪的道路，成为盘踞一方的黑恶势力头目。随着全国扫黑除恶专项斗争的开展，安欣再次获得了将犯罪分子一网打尽的机会。',
    posterSeq: 'tv-poster-03',
    posterWidth: 400,
    posterHeight: 560,
    isNew: false,
    isHot: true,
    updateDate: '2023-01-14',
    tags: ['犯罪', '扫黑', '口碑爆款', '年度最佳'],
  },
  {
    id: 'tv-4',
    title: '漫长的季节',
    titleEn: 'The Long Season',
    year: 2023,
    category: 'tv',
    genre: '悬疑',
    rating: 9.5,
    episodes: '12集全',
    director: '辛爽',
    cast: ['范伟', '秦昊', '陈明昊', '李庚希', '刘琳'],
    description: '出租车司机王响在二十年前失去了儿子，他一直无法释怀。一桩新的案件让过去的秘密重新浮出水面，一场横跨二十年的追寻真相之旅就此展开。',
    longDescription: '二十年前，东北小城桦林，钢厂火车司机王响意气风发。一系列意外的发生打碎了他的生活——儿子的离奇死亡、妻子的悲痛欲绝、自己下岗的命运。二十年后，王响成了一名出租车司机。一起新的失踪案，让那些被尘封的往事重新浮现。王响与他过去的妹夫龚彪、当年的刑警队长马德胜再次走到一起，三人共同踏上了揭开真相的道路。这不仅仅是一个悬疑故事，更是一曲献给那个时代和普通人的挽歌。',
    posterSeq: 'tv-poster-04',
    posterWidth: 400,
    posterHeight: 560,
    isNew: false,
    isHot: true,
    updateDate: '2023-04-22',
    tags: ['悬疑', '年代剧', '口碑神作', '豆瓣高分'],
  },
  {
    id: 'tv-5',
    title: '三体',
    titleEn: 'Three-Body',
    year: 2023,
    category: 'tv',
    genre: '科幻',
    rating: 8.8,
    episodes: '30集全',
    director: '杨磊',
    cast: ['张鲁一', '于和伟', '陈瑾', '王子文', '林永健'],
    description: '纳米科学家汪淼被警官史强带到一个神秘组织，由此接触到一个名为"科学边界"的组织，并卷入了一场关乎人类文明存亡的巨大危机之中。',
    longDescription: '2007年，地球基础科学出现了异常的扰动。纳米科学家汪淼被警官史强带到联合作战中心，并潜入名为"科学边界"的组织协助调查。在调查中，汪淼接触到了一个名为"三体"的虚拟现实游戏，并由此发现了地外文明"三体"的秘密。三体世界由于生存环境极度恶劣，决定入侵地球。一场跨越星际的文明对决即将开始。该剧改编自刘慈欣同名科幻巨著，是中国科幻电视剧的开山之作。',
    posterSeq: 'tv-poster-05',
    posterWidth: 400,
    posterHeight: 560,
    isNew: false,
    isHot: false,
    updateDate: '2023-01-15',
    tags: ['科幻', '刘慈欣', '大IP', '国产科幻剧'],
  },
  {
    id: 'tv-6',
    title: '去有风的地方',
    titleEn: 'Meet Yourself',
    year: 2023,
    category: 'tv',
    genre: '治愈',
    rating: 8.6,
    episodes: '40集全',
    director: '丁梓光',
    cast: ['刘亦菲', '李现', '胡冰卿', '牛骏峰', '吴彦姝'],
    description: '都市白领许红豆在闺蜜去世后，生活和工作陷入低谷。她独自前往大理云苗村的"有风小院"休息调整，在那里遇到了回乡创业的谢之遥。',
    longDescription: '许红豆因为闺蜜去世，生活和工作陷入低谷。她独自前往大理云苗村的"有风小院"休息调整。在那里，她遇到了辞去高薪工作回乡创业的谢之遥，还有一群从大城市过来的同龄人。在日常相处中，许红豆被村民们的真诚善良打动，也逐渐打开心扉。在有风的地方，她找到了生活的方向，也收获了温暖的爱情。这是一部关于治愈与重新出发的温情之作。',
    posterSeq: 'tv-poster-06',
    posterWidth: 400,
    posterHeight: 560,
    isNew: false,
    isHot: false,
    updateDate: '2023-01-03',
    tags: ['治愈', '田园', '大理', '神仙姐姐'],
  },
  {
    id: 'tv-7',
    title: '开端',
    titleEn: 'Reset',
    year: 2022,
    category: 'tv',
    genre: '悬疑',
    rating: 8.9,
    episodes: '15集全',
    director: '孙墨龙',
    cast: ['白敬亭', '赵今麦', '刘奕君', '黄觉', '刘丹'],
    description: '游戏架构师肖鹤云和大学生李诗情在遭遇公交车爆炸后，不断经历时间循环。他们必须找出真相，阻止爆炸，才能走出循环。',
    longDescription: '游戏架构师肖鹤云和大学生李诗情在遭遇公交车爆炸后，竟然"死而复生"，重新回到了公交车爆炸前的一段时间。两人发现自己陷入了时间循环之中。他们尝试了各种方法——下车、报警、阻止爆炸——但每次都以失败告终，然后重新回到起点。在一次次循环中，他们逐渐了解了车上每位乘客背后的故事，也一步步逼近了真相的核心。',
    posterSeq: 'tv-poster-07',
    posterWidth: 400,
    posterHeight: 560,
    isNew: false,
    isHot: false,
    updateDate: '2022-01-11',
    tags: ['悬疑', '时间循环', '国产好剧', '烧脑'],
  },
  {
    id: 'tv-8',
    title: '人世间',
    titleEn: 'A Lifelong Journey',
    year: 2022,
    category: 'tv',
    genre: '剧情',
    rating: 9.3,
    episodes: '58集全',
    director: '李路',
    cast: ['雷佳音', '辛柏青', '宋佳', '殷桃', '丁勇岱'],
    description: '从二十世纪七十年代末起，周家三兄妹在五十年间经历的人生起伏，折射出当代中国社会的巨大变迁。',
    longDescription: '上世纪七十年代末，北方某省会城市"光字片"区居住着周姓一家。父亲周志刚在西南参加"大三线"建设，长子周秉义响应国家号召成为第一批下乡知青，长女周蓉追随诗人丈夫远赴贵州乡村，只留下小弟周秉昆与母亲相依为命。在五十年的岁月里，周家人的命运与时代变迁紧密相连。他们经历了恢复高考、改革开放、国企改革、下岗潮等重大历史事件，在各自的岗位上为国家和社会的发展贡献力量。',
    posterSeq: 'tv-poster-08',
    posterWidth: 400,
    posterHeight: 560,
    isNew: false,
    isHot: false,
    updateDate: '2022-01-28',
    tags: ['剧情', '年代剧', '茅盾文学奖', '经典'],
  },
];

export const tvGenres = ['全部', '剧情', '古装', '犯罪', '悬疑', '科幻', '治愈', '都市', '爱情', '谍战', '历史', '武侠'];

export const getTVShowsByGenre = (genre: string): TVShow[] => {
  if (genre === '全部') return allTVShows;
  return allTVShows.filter((t) => t.genre === genre);
};

export const getTVShowById = (id: string): TVShow | undefined => {
  return allTVShows.find((t) => t.id === id);
};

export const getLatestTVShows = (count: number = 8): TVShow[] => {
  return [...allTVShows].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, count);
};

export const getHotTVShows = (count: number = 8): TVShow[] => {
  return [...allTVShows].filter((t) => t.isHot).sort((a, b) => b.rating - a.rating).slice(0, count);
};